import FreemiumEventCreateEmailPinVerificationStep from './FreemiumEventCreateEmailPinVerificationStep';

export default FreemiumEventCreateEmailPinVerificationStep;
